<!-- Button -->
<button mat-icon-button [matMenuTriggerFor]="languagesMenu">
    <span class="text-xl">{{ activeLanguage?.flag }}</span>
</button>

<!-- Language menu -->
<mat-menu [xPosition]="'before'" #languagesMenu="matMenu">
    <ng-container *ngFor="let lang of languages; trackBy: trackByFn">
        <button mat-menu-item (click)="setActiveLanguage(lang.code)"
            [class.bg-primary-50]="activeLanguage?.code === lang.code">
            <span class="flex items-center">
                <span class="text-xl mr-3">{{ lang.flag }}</span>
                <span>{{ lang.name }}</span>
            </span>
        </button>
    </ng-container>
</mat-menu>
